// import React, { useEffect, useRef, useState } from "react";
// import {
//   FaShoppingCart,
//   FaUser,
//   FaMapMarkerAlt,
//   FaBars,
//   FaTimes,
//   FaChevronDown,
// } from "react-icons/fa";
// import { GrSearch } from "react-icons/gr";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { logoutUser } from "../store/userSlice";
// import { clearCart } from "../store/cartSlice";
// import logo from "../assest/products/extra/logo.jpeg";

// const Header = () => {

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const user = useSelector((state) => state.user.user);
//   const cartCount = useSelector((state) => state.cart.cartCount);

//   const [search, setSearch] = useState("");
//   const [isSticky, setIsSticky] = useState(false);
//   const [mobileMenu, setMobileMenu] = useState(false);
//   const [profileOpen, setProfileOpen] = useState(false);

//   const profileRef = useRef();

//   // 🔥 Sticky effect
//   useEffect(() => {
//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 10);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // 🔥 Close profile dropdown
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setProfileOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleLogout = async () => {
//     await fetch("https://lappyshop.onrender.com/api/userLogout", {
//       credentials: "include"
//     });
//     dispatch(logoutUser());
//     dispatch(clearCart());
//     navigate("/");
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (search.trim()) {
//       navigate(`/search?q=${search}`);
//     }
//   };

//   return (
//     <header
//       className={`w-full fixed top-0 z-50 transition-all duration-300 
//       ${isSticky 
//         ? "shadow-lg backdrop-blur-md bg-[#1677A8]/90" 
//         : "bg-[#1677A8]"
//       }`}
//     >

//       <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between text-white">

//         {/* 🔥 LOGO ONLY */}
//         <Link to="/" className="flex items-center">

//        <div className="h-full flex items-center hover:scale-105 transition">

//   <img
//     src={logo}
//     alt="logo"
//     className="h-12 md:h-20 rounded object-contain"
//   />

// </div>

//         </Link>

//         {/* 🔥 SEARCH */}
//         <form
//           onSubmit={handleSearchSubmit}
//           className="hidden lg:flex items-center bg-white rounded-full overflow-hidden w-[500px] shadow-md"
//         >
//           <div className="px-3 text-gray-500">
//             <GrSearch />
//           </div>

//           <input
//             type="text"
//             placeholder="Search laptops..."
//             className="w-full py-2 outline-none text-black text-sm"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />

//           {search && (
//             <button
//               type="button"
//               onClick={() => setSearch("")}
//               className="px-4 text-xs text-gray-500"
//             >
//               Clear
//             </button>
//           )}
//         </form>

//         {/* 🔥 RIGHT SIDE */}
//         <div className="hidden lg:flex items-center gap-6">

//           {/* CART */}
//           <Link to="/cart" className="relative text-xl hover:scale-110 transition">
//             <FaShoppingCart />
//             {cartCount > 0 && (
//               <span className="absolute -top-2 -right-2 bg-red-500 text-xs w-5 h-5 flex items-center justify-center rounded-full">
//                 {cartCount}
//               </span>
//             )}
//           </Link>

//           {/* PROFILE */}
//           <div className="relative" ref={profileRef}>
//             {user ? (
//               <div
//                 onClick={() => setProfileOpen(!profileOpen)}
//                 className="cursor-pointer flex items-center gap-1"
//               >
//                 <FaUser />
//                 <FaChevronDown className="text-xs" />
//               </div>
//             ) : (
//               <Link to="/login">
//                 <FaUser />
//               </Link>
//             )}

//             {profileOpen && (
//               <div className="absolute right-0 mt-3 w-56 bg-white text-black shadow-2xl rounded-xl p-4">

//                 <Link to="/account" className="block py-2 hover:text-blue-600">
//                   Account
//                 </Link>

//                    {user?.role === "ADMIN" && (
//                               <Link
//                                 to="/admin-panel"
//                                 className="text-blue-600 font-medium"
//                               >
//                                 Admin-Panel
//                               </Link>
//                             )}

//                 <hr className="my-3" />

//                 <button
//                   onClick={handleLogout}
//                   className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded"
//                 >
//                   Logout
//                 </button>

//               </div>
//             )}
//           </div>

//           {/* LOCATION */}
//           <Link to="/store">
//             <FaMapMarkerAlt />
//           </Link>

//         </div>

//         {/* 🔥 MOBILE MENU */}
//         <div className="lg:hidden text-2xl">
//           {mobileMenu ? (
//             <FaTimes onClick={() => setMobileMenu(false)} />
//           ) : (
//             <FaBars onClick={() => setMobileMenu(true)} />
//           )}
//         </div>

//       </div>

//       {/* 🔥 MOBILE DROPDOWN */}
//       {mobileMenu && (
//         <div className="lg:hidden bg-white text-black shadow-md p-4">

//           {/* SEARCH */}
//           <form
//             onSubmit={handleSearchSubmit}
//             className="flex items-center bg-gray-100 rounded-full mb-4"
//           >
//             <input
//               className="w-full p-2 bg-transparent outline-none"
//               placeholder="Search..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </form>

//           {/* MENU */}
//           <ul className="space-y-3">

//             <li>
//               <Link to="/cart">Cart ({cartCount})</Link>
//             </li>

//             <li>
//               <Link to="/account">Account</Link>
//             </li>

//           </ul>

//         </div>
//       )}

//     </header>
//   );
// };

// export default Header;
import React, { useEffect, useRef, useState } from "react";
import {
  FaShoppingCart,
  FaUser,
  FaMapMarkerAlt,
  FaChevronDown,
} from "react-icons/fa";
import { GrSearch } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../store/userSlice";
import { clearCart } from "../store/cartSlice";
import logo from "../assest/products/extra/logo.jpeg";

const Header = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);
  const cartCount = useSelector((state) => state.cart.cartCount);

  const [search, setSearch] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const profileRef = useRef();

  // 🔥 Sticky effect
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 🔥 Close profile dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await fetch("https://lappyshop.onrender.com/api/userLogout", {
      credentials: "include"
    });
    dispatch(logoutUser());
    dispatch(clearCart());
    navigate("/");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/search?q=${search}`);
    }
  };

  return (
    <header
      className={`hidden md:block w-full fixed top-0 z-50 transition-all duration-300 
      ${isSticky 
        ? "shadow-lg backdrop-blur-md bg-[#1677A8]/90" 
        : "bg-[#1677A8]"
      }`}
    >

      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between text-white">

        {/* 🔥 LOGO */}
        <Link to="/" className="flex items-center">
          <div className="h-full flex items-center hover:scale-105 transition">
            <img
              src={logo}
              alt="logo"
              className="h-12 md:h-20 rounded object-contain"
            />
          </div>
        </Link>

        {/* 🔥 SEARCH */}
        <form
          onSubmit={handleSearchSubmit}
          className="flex items-center bg-white rounded-full overflow-hidden w-[500px] shadow-md"
        >
          <div className="px-3 text-gray-500">
            <GrSearch />
          </div>

          <input
            type="text"
            placeholder="Search laptops..."
            className="w-full py-2 outline-none text-black text-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {search && (
            <button
              type="button"
              onClick={() => setSearch("")}
              className="px-4 text-xs text-gray-500"
            >
              Clear
            </button>
          )}
        </form>

        {/* 🔥 RIGHT SIDE */}
        <div className="flex items-center gap-6">

          {/* CART */}
          <Link
            to="/cart"
            id="cart-icon"
            className="relative text-xl hover:scale-110 transition"
          >
            <FaShoppingCart />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-xs w-5 h-5 flex items-center justify-center rounded-full">
                {cartCount}
              </span>
            )}
          </Link>

          {/* PROFILE */}
          <div className="relative" ref={profileRef}>
            {user ? (
              <div
                onClick={() => setProfileOpen(!profileOpen)}
                className="cursor-pointer flex items-center gap-1"
              >
                <FaUser />
                <FaChevronDown className="text-xs" />
              </div>
            ) : (
              <Link to="/login">
                <FaUser />
              </Link>
            )}

            {profileOpen && (
              <div className="absolute right-0 mt-3 w-56 bg-white text-black shadow-2xl rounded-xl p-4">

                <Link to="/account" className="block py-2 hover:text-blue-600">
                  Account
                </Link>

                {user?.role === "ADMIN" && (
                  <Link
                    to="/admin-panel"
                    className="text-blue-600 font-medium"
                  >
                    Admin Panel
                  </Link>
                )}

                <hr className="my-3" />

                <button
                  onClick={handleLogout}
                  className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded"
                >
                  Logout
                </button>

              </div>
            )}
          </div>

          {/* LOCATION */}
          <Link to="/store">
            <FaMapMarkerAlt />
          </Link>

        </div>

      </div>

    </header>
  );
};

export default Header;